import oktaAuth from '../config/okta';

const API_URL = process.env.REACT_APP_API_URL;

async function getAuthHeaders() {
  const accessToken = await oktaAuth.tokenManager.get('accessToken');
  if (!accessToken || !accessToken.accessToken) {
    throw new Error('No access token available');
  }
  return {
    Authorization: `Bearer ${accessToken.accessToken}`,
    'Content-Type': 'application/json',
  };
}

async function handleResponse(response) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  return response.json();
}

export const api = {
  async getUsers(params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = `${API_URL}/users${query ? '?' + query : ''}`;
    const response = await fetch(url, {
      headers: await getAuthHeaders()
    });
    return handleResponse(response);
  },

  async getUser(userId) {
    const response = await fetch(`${API_URL}/users/${userId}`, {
      headers: await getAuthHeaders()
    });
    return handleResponse(response);
  },

  async createUser(userData) {
    const response = await fetch(`${API_URL}/users`, {
      method: 'POST',
      headers: await getAuthHeaders(),
      body: JSON.stringify(userData)
    });
    return handleResponse(response);
  },

  async updateUser(userId, updates) {
    const response = await fetch(`${API_URL}/users/${userId}`, {
      method: 'PUT',
      headers: await getAuthHeaders(),
      body: JSON.stringify(updates)
    });
    return handleResponse(response);
  },

  async deleteUser(userId) {
    const response = await fetch(`${API_URL}/users/${userId}`, {
      method: 'DELETE',
      headers: await getAuthHeaders()
    });
    return handleResponse(response);
  },

  async getUserStats(userId) {
    const response = await fetch(`${API_URL}/users/${userId}/stats`, {
      headers: await getAuthHeaders()
    });
    return handleResponse(response);
  }
};
